import axios from 'axios';

jQuery('#form_contact').submit(function () {
    // we stoped it
    event.preventDefault();
    // needs for recaptacha ready
    grecaptcha.ready(function () {
        // do request for recaptcha token
        // response is promise with passed token
        grecaptcha.execute(G_recaptcha, {action: 'form_contact'}).then(function (token) {
            // add token to form
            $('#form_contact').prepend('<input type="hidden" name="token" value="' + token + '">');
            $('#form_contact').prepend('<input type="hidden" name="action" value="form_contact">');
            // submit form now
            $('#form_contact').unbind('submit').submit();
        });
    });
});

if (jQuery("input[type=file]").length > 0) {
    jQuery("input[type=file]").each(function () {
        const label = jQuery(this).siblings('.help-block').text();

        let html = "";
        html += `<div class='fakefileinput'><button class='choosefile btn btn-default'>Choisir un fichier</button><span>${ label }</span></div>`;
        jQuery(this).parent().append(html);

        jQuery(this).change(function () {
            const val = jQuery(this).val();
            jQuery(this).siblings('.fakefileinput').children('span').text(val);
        });
    });
}

function updateEmail(cp)
{
    axios.get(`/wp-json/getters/contact?s=${ cp }`)
        .then(function (response) {
            // handle success
            const data = response.data;
            jQuery(".email-dest").val(data.email);
        })
        .catch(function (error) {
            // handle error
            console.log(error);
        })
        .then(function () {
            // always executed
        });
}

jQuery('.zipcode input').change(function () {
    const cp = jQuery(this).val();
    updateEmail(cp);
});

jQuery(document).ready(function(){
    const html = '<span class="checkmark"></span>';
    jQuery('.custom-radio .radio-inline, .caldera-forms-consent-field').append(html);
});


// WEBPACK FOOTER //
// ./src/js/app/forms.js